module.exports = __webpack_public_path__ + "media/key_settings/flag-851fda93.svg";